/**
 * Randomizes the --product-overlay-color CSS variable across a collection
 * grid: one color from the pool becomes the page-wide default (always
 * including the first product), and the other five appear as accents on
 * roughly every 3rd-6th product, with a slim chance of two accents landing
 * back to back.
 *
 * Colors are read from CSS (--product-overlay-pool-1 ... -6 on :root in
 * custom.css / custom.css.liquid) -- edit them there, not here.
 */
(function () {
  'use strict';

  var GRID_SCOPE_SELECTOR = '.collection-main';
  var THUMBNAIL_SELECTOR = '.product__thumbnail';
  var VAR_NAME = '--product-overlay-color';
  var POOL_VAR_PREFIX = '--product-overlay-pool-';
  var POOL_SIZE = 6;
  var MIN_GAP = 3;
  var MAX_GAP = 6;

  // Chance (0-1) that two accent colors land right next to each other,
  // bypassing MIN_GAP for that one pair. Keep this low -- values above
  // ~0.1 (10%) will start to look like a second, denser pattern rather
  // than an occasional exception.
  var DOUBLE_ACCENT_CHANCE = 0.1;

  function getPoolColors() {
    var styles = getComputedStyle(document.documentElement);
    var pool = [];
    for (var i = 1; i <= POOL_SIZE; i++) {
      var value = styles.getPropertyValue(POOL_VAR_PREFIX + i).trim();
      if (value) pool.push(value);
    }
    return pool;
  }

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function pickRandom(arr) {
    return arr[randomInt(0, arr.length - 1)];
  }

  function initRandomizer() {
    var scope = document.querySelector(GRID_SCOPE_SELECTOR);
    if (!scope) return;

    var pool = getPoolColors();
    if (pool.length < 2) return; // need at least a base + one accent color

    // Pick one base color for this page view. Setting it on <html> means
    // every thumbnail inherits it by default via the CSS variable fallback.
    var baseIndex = randomInt(0, pool.length - 1);
    var baseColor = pool[baseIndex];
    document.documentElement.style.setProperty(VAR_NAME, baseColor);

    var accentColors = pool.slice(0, baseIndex).concat(pool.slice(baseIndex + 1));

    function paint() {
      var items = scope.querySelectorAll(THUMBNAIL_SELECTOR);
      if (!items.length) return;

      // Clear previous accent overrides so a repaint always starts clean.
      Array.prototype.forEach.call(items, function (item) {
        item.style.removeProperty(VAR_NAME);
      });

      var lastAccent = null;
      var justDoubled = false;

      // Position 1 (the first product) always stays the base color, so the
      // first accent can only land at MIN_GAP or later.
      var next = randomInt(MIN_GAP, MAX_GAP);
      if (next < 2) next = 2;

      Array.prototype.forEach.call(items, function (item, index) {
        var position = index + 1;
        if (position === next) {
          var choices = accentColors.filter(function (color) {
            return color !== lastAccent;
          });
          if (!choices.length) choices = accentColors;

          var accent = pickRandom(choices);
          item.style.setProperty(VAR_NAME, accent);
          lastAccent = accent;

          // Slim, non-chaining chance to place a second accent immediately
          // next to this one, ignoring MIN_GAP just this once.
          if (!justDoubled && Math.random() < DOUBLE_ACCENT_CHANCE) {
            next = position + 1;
            justDoubled = true;
          } else {
            next = position + randomInt(MIN_GAP, MAX_GAP);
            justDoubled = false;
          }
        }
      });
    }

    paint();

    // Re-run the pattern whenever the grid changes (pagination, infinite
    // scroll, or a filter/sort reload) so newly loaded products get covered.
    // The base color picked above stays fixed for the whole pageview.
    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(paint, 150);
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRandomizer);
  } else {
    initRandomizer();
  }
})();
